import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSwitch
} from 'packages';

function EnvironmentVariableCrud({ form, handleFinish }) {
  const SecretWidget = ({ value, onChange }) => (
    <KoSwitch checked={value} onChange={onChange} />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'key', label: 'Key', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'VARIABLE_NAME' } },
      { key: 'value', label: 'Value', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'Variable value' } },
      { key: 'isSecret', label: 'Secret', colSpan: 1, widget: SecretWidget, forwardRef: true },
      { key: 'description', label: 'Description', colSpan: 3, widget: KoInput, widgetProps: { placeholder: 'Variable description' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default EnvironmentVariableCrud;
